import React, { useEffect, useState, useCallback } from 'react'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import axios from 'axios'
import { toast } from 'react-toastify'
import parse from 'html-react-parser'
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha'

import styles from '../../../inrernShipsBlock/form/localForm/styles.module.scss'

const FormEduc = ({ setSuccessSend, setActivePopUp, checkDomenNameState, season, captchaSiteKey }) => {
  const [mobile, setMobile] = useState('')
  const [errorMobile, setErrorMobile] = useState(false)
  const [success2, setSuccess] = useState(false)
  const [blurSuccess, setBlurSuccess] = useState(false)
  const [file, setFile] = useState(null)
  const [blurFile, setBlurFile] = useState(false)
  const [checkResume, setCheckResume] = useState('')
  const [blurResum, setBlurResum] = useState(false)

  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const handleChallengeHidden = useCallback(() => setVisible(false), [])
  const handleButtonClick = () => setVisible(true)

  const schemaIceForm = yup
    .object({
      FIO: yup
        .string()
        .matches(/^[а-яА-ЯёЁ]+([-][а-яА-ЯёЁ]+)?(\s[а-яА-ЯёЁ]+){1,2}$/, 'Неверный формат данных')
        .required('Это — обязательное поле'),
      city: yup
        .string()
        .matches(
          /^(([a-zA-Zа-яА-ЯёЁ]*(\s*)\([a-zA-Zа-яА-ЯёЁ\s]*\))|([a-zA-Zа-яА-ЯёЁ\-0-9]*)|([a-zA-Zа-яА-ЯёЁ]+[-|\s]?[a-zA-Zа-яА-ЯёЁ]*[-|\s]?[a-zA-Zа-яА-ЯёЁ]*[-|\s]?[a-zA-Zа-яА-ЯёЁ]*))$/,
          'Неверный формат данных'
        )
        .required('Это — обязательное поле'),
      email: yup
        .string()
        .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, 'Неверный формат данных')
        .required('Это — обязательное поле'),
      course: yup.string().required('Это — обязательное поле'),
      letter: yup.string().required('Это — обязательное поле'),
      university: yup.string().required('Это — обязательное поле')
    })
    .required()

  // setting form - inputs
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schemaIceForm)
  })

  const onChanges2 = data => {
    let checkFIO = watch('FIO')
    let finallyFIO = []
    if (checkFIO) {
      finallyFIO = checkFIO.split(' ')
    }

    const obj = {
      positionId: null,
      positionName: null,
      firstName: finallyFIO[1],
      middleName: finallyFIO[2],
      lastName: finallyFIO[0],
      city: data.city,
      unitName: null,
      phoneNumber: '+' + mobile,
      email: data.email,
      link: data.resume,
      info: data.letter,
      course: data.course,
      faculty: null,
      department: null,
      direction: null,
      university: data.university,
      nameEducation: season,
      type: 'EDUCATION',
      token: token,
    }

    const json = JSON.stringify(obj)
    const blob = new Blob([json], {
      type: 'application/json'
    })

    let saveRequest = new FormData()
    saveRequest.append('saveRequest', blob)
    saveRequest.append('file', file)

    mobile.length < 11 && setErrorMobile(true)
    !file && setBlurFile(true)
    !success2 && setBlurSuccess(true)

    let _protocol = window.location.protocol

    if (mobile.length === 11 && file && success2 && file?.type === 'application/pdf' && file?.size < 4999995) {
      axios({
        method: 'post',
        url: `${_protocol}//${checkDomenNameState}/api/v1/response/save`,
        data: saveRequest,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          if (response.data.status != "error") {
            setSuccessSend(true)
            reset()
            setMobile('')
            setBlurFile(false)
            // eslint-disable-next-line no-undef
            ym(94755545,'reachGoal','programm_form_submit')

            // window._tmr = window._tmr || [];
            // window._tmr.push({ type: 'reachGoal', id: 3398932, goal: 'otpravit_zayavku'});
          } else {
            let _error = <>{parse(response.data.message)}</>
            toast.error(_error);
          }
        })
        .catch(() => {
          setSuccess(false)
          toast.error('Отклик не отправился!')
        })
        .finally(() => {
          setBlurSuccess(false)
          setErrorMobile(false)
        })
    }
  }

  let watchResume = watch('resume')
  useEffect(() => {
    const regExpPhone = new RegExp('^(https?|ftp|file)://[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]')

    let total = ''
    if (watchResume) {
      total = regExpPhone?.test(watchResume)
    }
    setCheckResume(total)
    if (watchResume) {
      setBlurResum(true)
    } else {
      setBlurResum(false)
    }
  }, [watchResume])

  return (
    <div>
      <form className={styles.form_block_listing_wrapper9} onSubmit={handleSubmit(onChanges2)}>
        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={errors.FIO?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='FIO'>Фамилия, имя, отчество</label>
            <input
              {...register('FIO')}
              placeholder='Например, Иван Иванович Иванов'
              type='text'
              name='FIO'
              maxLength='50'
            />
            {errors?.FIO && <p className={styles.left_input_error}>{errors.FIO?.message}</p>}
          </div>

          <div
            className={errors.city?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='city'>Город</label>
            <input {...register('city')} placeholder='Например, Москва' type='text' name='city' />
            {errors?.city && <p className={styles.left_input_error}>{errors.city?.message}</p>}
          </div>
        </div>

        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={
              errorMobile && mobile?.length !== 11
                ? styles.form_block_listing_item2_error
                : styles.form_block_listing_item2
            }
          >
            <label htmlFor='telephone'>Телефон</label>
            <input
              value={mobile}
              onChange={e => setMobile(e.target.value)}
              maxLength='11'
              placeholder='Например, 7 (777) 777-77-77'
              type='tel'
              name='telephone'
            />
            {errorMobile && mobile?.length !== 11 && <p className={styles.left_input_error}>Неверный формат номера</p>}
            {errorMobile && mobile?.length === 0 && <p className={styles.left_input_error}>Это — обязательное поле</p>}
          </div>
          <div
            className={errors.email?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='email'>Электронная почта</label>
            <input {...register('email')} placeholder='Например, example@example.com' type='email' name='email' />
            {errors?.email && <p className={styles.left_input_error}>{errors.email?.message}</p>}
          </div>
        </div>

        <div className='flex justify-between max-lg:flex-col'>
          <div
            className={
              errors.university?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2
            }
          >
            <label htmlFor='university'>ВУЗ</label>
            <input
              {...register('university')}
              placeholder='Например, МГУ имени М. В. Ломоносова'
              type='text'
              name='university'
            />
            {errors?.university && <p className={styles.left_input_error}>{errors.university?.message}</p>}
          </div>

          <div
            className={errors.course?.message ? styles.form_block_listing_item2_error : styles.form_block_listing_item2}
          >
            <label htmlFor='course'>Курс</label>
            <input {...register('course')} placeholder='Например, 4 курс' type='tel' maxLength='5' name='course' />
            {errors?.course && <p className={styles.left_input_error}>{errors.course?.message}</p>}
          </div>
        </div>

        <div className={errors.file?.message ? styles.form_block_listing_file_error : styles.form_block_listing_file}>
          <label htmlFor='file'>Загрузите файл резюме</label>
          <p>1 файл .pdf, не более 5 Мб</p>
          <input type='file' accept='application/pdf' onChange={e => setFile(e.target.files[0])} />
          {blurFile && !file && <p className={styles.left_input_error}>Это — обязательное поле</p>}
          {file?.type !== 'application/pdf' && blurFile && file && (
            <p className={styles.left_input_error}>Только pdf формат!</p>
          )}
          {file?.size > 4999995 && blurFile && file && (
            <p className={styles.left_input_error}>Размер файла не более 5мб!</p>
          )}
        </div>

        <div
          className={!checkResume && blurResum ? styles.form_block_listing_item_error : styles.form_block_listing_item}
        >
          <label htmlFor='resume'>Ваша ссылка на резюме</label>
          <input
            {...register('resume')}
            placeholder='Например, на HeadHunter, Superjob или Хабр Карьере'
            type='text'
            name='resume'
          />
          {!checkResume && blurResum && <p className={styles.left_input_error}>Неверная ссылка!</p>}
        </div>

        <div className={errors.letter?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
          <label htmlFor='letter'>Мотивационное письмо</label>
          <input
            {...register('letter')}
            placeholder='Я хочу стажироваться в Generium, потому что...'
            type='text'
            name='letter'
            maxLength='1000'
          />
          {errors?.letter && <p className={styles.left_input_error}>{errors.letter?.message}</p>}
        </div>
        <div
          className={
            !success2 && blurSuccess ? styles.form_block_listing_checkbox_error : styles.form_block_listing_checkbox
          }
        >
          <input onClick={() => {setSuccess(!success2); handleButtonClick();}} type='checkbox' />
          <p>
            Я даю согласие на{' '}
            <a href='/privacy-policy' target='_blank'>
              <span onClick={() => setActivePopUp(null)}>обработку моих персональных данных</span>
            </a>{' '}
          </p>
          {success2 === false && blurSuccess === true && (
            <p className={styles.left_input_error}>Эта галочка обязательна!</p>
          )}
        </div>

        <InvisibleSmartCaptcha
          sitekey={captchaSiteKey}
          onSuccess={setToken}
          onChallengeHidden={handleChallengeHidden}
          visible={visible}
        />

        <button
          className={
            isValid &&
            mobile?.length === 11 &&
            file &&
            success2 &&
            file?.type === 'application/pdf' &&
            file?.size < 4999995
              ? styles.form_block_listing_btn_active
              : styles.form_block_listing_btn
          }
        >
          Отправить заявку
          <span>&rarr;</span>
        </button>
      </form>
    </div>
  )
}

export default FormEduc
